import { Injector, Directive } from '@angular/core';
import {ApBaseModalComponent} from './ap-base-modal.component';
import {apModalCancelled, apModalClosed, ApModalResult} from './ApModalResult';

import {ApModalReason} from './ApModalReason';

// Allows modal to return a more comprehensive result, including how it was closed, etc
@Directive()
export abstract class ApComplexModal<T, TData = unknown> extends ApBaseModalComponent<ApModalResult<T>, TData> {
  constructor(
    elementInjector: Injector,
  ) {
    super(elementInjector);
  }

  // I prefixed these methods, so they are less likely
  // to conflict with methods defined in inheriting classes

  // close the activeModal because the user is done and there is a successful result
  apClose(result: T): void {
    const modalResult = apModalClosed(result);
    return this.closeModal(modalResult);
  }

  // close the activeModal because the user is done and there is a successful result (which is a promise)
  apCloseWithPromise(result: PromiseLike<T>): void {
    const modalResultPromise = result.then((x) => {
      const modalResult = apModalClosed(x);
      return modalResult;
    });

    return this.closeModal(modalResultPromise);
  }

  // close the activeModal because the user has cancelled the operation,
  // but there is not an error that should be passed along
  apUserCancel(): void {
    const modalResult = apModalCancelled<T>(
      ApModalReason.UserCancel,
    );
    return this.closeModal(modalResult);
  }

  protected override onHide(_reason: string): void {
    const modalResult = apModalCancelled<T>(
      ApModalReason.Unknown,
    );
    return this.emitWithoutClose(modalResult);
  }
}
